/* eslint-disable no-use-before-define */
import React from 'react'
import { $, Fields, fmt, hideModal } from '../../twd'
import Grid from './grid'
import ViewMore from '../view-more'
import useOfferingsModal from './use-offerings-modal';

export default ({name, maturity, ts, params, from}) => {

    const { matTerm, status, rows, count, page, reset, setPage } = useOfferingsModal({name, ts, params, maturity})

    return <React.Fragment>
    <div
        data-name="offerings-modal-close-link"
        className="modal-dialog modal-lg">
    <div className="modal-content">
    <div className="container" style={{background:"#ffffff" }}>

    <div className="row"><div className="col-md-12">
        <div className="vertical-offset-md"></div>
        <button
            className="close"
            aria-label="close"
            data-name="offerings-modal-close-link"
            type="button"
            onClick={() => {
                reset()
                hideModal()
            }}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>
    </div></div>

    <div className="row vertical-offset-base">
        <div className="col-md-9">
            <h2><b>{name}</b></h2>
        </div>
        <div className="col-md-3 text-right text-small">
         As of {fmt.mdy(new Date())}
        </div>

    </div>

    <div className="row vertical-offset-base">
        <div className="col-md-6 col-xs-12">
        <div className="select-wrapper">
        <Fields.Select
            label="Maturity range"
            data-name="offerings-modal-maturity-range"
            id="offerings-modal-maturity-range"
            value={matTerm}
            className="form-control"
            onChange={() => {}}
            options={[{
                value:'LT_3', label:'Shorter term (<3 years)'
            }, {
                value:"3_TO_5", label:"Shorter term (3-5 years)"
            }, {
                value:"5_TO_10", label:"Medium term (5-10 years)"
            }, {
                value:"10_TO_20", label:"Longer term (10-20 years)"
            }, {
                value:"GT_20", label:"Longer term (>20 years)"
            }, {
                value:"ALL", label:"All"
            }]}
        />
        </div>
        </div>

        <div className="col-md-3 col-xs-12">
        <label>&nbsp;</label>
        <button
            type="button"
            data-name="offerings-modal-update-results-button"
            className="btn btn-primary-outline btn-block"
            onClick={() => {
                let v = $('#offerings-modal-maturity-range').val()
                reset(v)
            }}
        >Update results</button>
        </div>
    </div>

    <div className="row vertical-offset-base">
        <Grid rows={rows} from={from} />
        <ViewMore
            rows={rows}
            status={status}
            count={count}
            onLoadMore={() => { setPage(page + 1)}} />

    </div>

    </div>
    </div>
    </div>

    </React.Fragment>
}


